import { NgTemplateOutlet } from '@angular/common';
import { Component, inject, viewChild } from '@angular/core';

import { DropdownHeaderComponent } from '../../../../../common/dropdown/dropdown-header/dropdown-header.component';
import { Select2ListItemDirective } from '../../../default-templates/list-item/list-item.directive';
import type { Select2Item } from '../../../types';
import { GROUPS_FEATURE } from '../types';

@Component({
  selector: 'rt-select-list-item-wrapper',
  imports: [Select2ListItemDirective, NgTemplateOutlet, DropdownHeaderComponent],
  template: `
    <ng-container
      *rtSelectListItem="
        selectType;
        let selectCtrl;
        let item = item;
        let isHoverState = isHoverState;
        let index = index;
        let isLast = isLast
      "
    >
      @if (groupsFeature.headers[index]; as header) {
        <rt-dropdown-header [isSubheading]="true">
          {{ header }}
        </rt-dropdown-header>
      }
      <ng-template
        [ngTemplateOutlet]="groupsFeature.listItem.templateRef"
        [ngTemplateOutletContext]="{ $implicit: selectCtrl, item, isHoverState, index, isLast }"
      ></ng-template>
    </ng-container>
  `,
})
export class GroupsListItemWrapperComponent {
  public directive = viewChild.required(Select2ListItemDirective);
  public selectType: { items: Select2Item[] };
  public groupsFeature = inject(GROUPS_FEATURE);
}
